import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderEditTemplateComponent } from './work-order-edit-template.component';
import { MatCardModule } from '@angular/material/card';
import { EditorEditModule } from '../../../../editor/editor-edit/editor-edit.module';
import { TranslateModule } from '@ngx-translate/core';
import { CtButtonModule } from '@ctsolution/ct-framework';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    EditorEditModule,
    TranslateModule,
    CtButtonModule
  ],
  declarations: [WorkOrderEditTemplateComponent],
  exports : [WorkOrderEditTemplateComponent]
})
export class WorkOrderEditTemplateModule { }
